export const translations = {
  en: {
    nav: {
      pages: 'Pages',
      contacts: 'Contacts',
      regulations: 'Regulations',
      aboutUs: 'About Us',
      login: 'Login',
      freeConsultation: 'Free Consultation',
      home: 'Home',
      privacyPolicy: 'Privacy Policy'
    },
    hero: {
      title: 'Get your money back from a Fraud',
      subtitle: 'If you have been a victim of fraudulent companies, get in touch with our team of experts and they will help you get back everything',
      formTitle: 'Free Consultation Form',
      name: 'Full Name',
      namePlaceholder: 'Enter your name',
      email: 'Email Address',
      emailPlaceholder: 'your@email.com',
      phone: 'Phone Number',
      phonePlaceholder: 'Phone number',
      amountLost: 'How much did you lose?',
      amountPlaceholder: 'Select amount range',
      message: 'Tell us about your situation (optional)',
      messagePlaceholder: 'Briefly describe what happened...',
      submit: 'GET A FREE CONSULTATION',
      submitting: 'SUBMITTING...'
    },
    amounts: {
      'less-5000': 'Less than $5,000',
      '5000-10000': '$5,000 – $10,000',
      '10000-20000': '$10,000 – $20,000',
      '20000-40000': '$20,000 – $40,000',
      '40000-80000': '$40,000 – $80,000',
      '80000-160000': '$80,000 – $160,000',
      '160000-plus': '$160,000 and up'
    },
    regulatory: {
      text: 'All actions taken by our company are conducted under the supervision and guidance of the following regulatory bodies and partners.'
    },
    howItWorks: {
      title: 'How it Works',
      step1Title: 'Review your case',
      step1Desc: 'Performing preliminary checks to assess whether the case can result in a substantial recovery, based on our experience.',
      step2Title: 'Gather the evidence',
      step2Desc: 'Collecting all the information and documentation required to successfully pursue your case.',
      step3Title: 'Confront the entities',
      step3Desc: 'Systematically confronting the relevant entities that have facilitated the illicit transfer of your wealth.',
      step4Title: 'Get your money back',
      step4Desc: "We take pride in our track record and assure you that we'll go to great lengths to get your money back."
    },
    moneyRetrieved: {
      title: 'Money retrieved in 2021-2026',
      subtitle: 'Our team of experts secures refunds on a daily basis. We assist businesses as well as individuals in their pursuit of funds lost to scammers.',
      amount: '$78,450,883',
      subtext: 'Successfully Recovered for Our Clients',
      button: 'Get a Free Consultation'
    },
    whyUs: {
      title1: 'Why work with us?',
      desc1: "The short answer: We only take on cases we believe can result in a substantial recovery. Your time is as valuable as ours, and that's why we are completely transparent in our evaluation of every case.",
      title2: 'Your money back guarantee',
      desc2: 'The fund recovery process can be a lengthy one and requires perseverance. Therefore it is vital that our clients are ready for it and trust us every step of the way. So if for any reason you are doubtful, you can ask for a full refund within the first 14 business days of the process.'
    },
    services: {
      title: 'Fraud Recovery Services',
      subtitle: 'We specialize in recovering funds lost to various types of financial fraud',
      howWeWork: 'How we work to get our clients money back',
      howWeWorkDesc: 'First, our team of financial experts secures the relevant information from you, the victim of the fraud. Then our recovery specialists, and legal department, track down and confront the scammers.',
      getConsultation: 'Get a Free Consultation',
      binaryOptions: 'Binary Options Trading',
      cryptocurrency: 'Cryptocurrency',
      forex: 'Forex',
      romance: 'Romance',
      property: 'Property',
      creditCard: 'Credit Card Phishing',
      stockTrading: 'Stock Trading',
      other: 'Other'
    },
    team: {
      title: 'Our Team',
      subtitle: 'Meet our dedicated team of professionals specializing in recovering stolen cryptocurrency and funds. We bring together experts in blockchain technology and cybersecurity to help you fight back against fraud.'
    },
    about: {
      sectionTitle: 'More about Trust Back and the chargeback industry',
      accordion1Title: 'Learn more about Trust Back and the chargeback industry right here',
      accordion1Text1: 'Online scams are prevalent among illegitimate shops and merchants on the internet today. It is laden with untrustworthy transactions that seek to victimize those who are vulnerable.',
      accordion1Text2: 'For instance, there are a lot of online markets and traders that can easily fool people by posing as a legitimate authority. Falling victim into this kind of scam can be really frustrating and painful.',
      accordion2Title: 'The chargeback industry',
      accordion2Text1: 'A chargeback is characterized as the action or process of filing a request for retrieval of funds by the customer either with a bank. The chargeback method is created in consideration of the customer\'s safety and protection from scams.',
      accordion2Text2: 'Rather than the conventional means of asking for the money back, the chargeback method asks the bank directly for a refund rather than the shop or merchant itself.',
      accordion3Title: 'Funds recovery with Trust Back',
      accordion3Text1: 'Trust Back offers this kind of service with wealth recovery experts and fund recovery specialists \u2013 ensuring that you get your investments back from scammers.',
      accordion3Text2: 'This is a service employed by victims that have been duped by online fraudulent crimes to retrieve their money from bogus merchants and trader scams.',
      accordion4Title: 'Recover from online trading scams',
      accordion4Q1: 'How can I recover my lost money from Forex?',
      accordion4Q2: 'How to recover trading loss?',
      accordion4Text1: 'These questions linger among those who have fallen target to online trading scams victims. However, with Trust Back, getting your money back quickly is not a problem.',
      accordion4Text2: 'Scams in online trading are connected to investment scams that are prevalent in the trading markets.',
      accordion5Title: 'About Trust Back',
      accordion5Text1: 'Trust Back has one mission: to protect people from frauds and scams online worldwide, whatever it takes.',
      accordion5Text2: 'Our team is composed of skilled experts and professionals with magnificent long-time experience.',
      accordion5Text3: 'If you have been victimized, you have the right to recover what you have lost. With the chargeback industry in effect and the professionals of Trust Back, get back what is yours.'
    },
    contacts: {
      title: 'Contacts',
      heroText: 'If you have fallen victim to fraud and want to recover your funds, our team is ready to help you. We specialize in recovering stolen cryptocurrency and offer professional services to help you reclaim your assets.',
      getConsultation: 'GET A FREE CONSULTATION',
      franceOffice: 'France Office',
      polandOffice: 'Poland Office',
      consultationsTitle: 'Consultations',
      consultationsText: 'We offer a free initial consultation during which we will assess your situation and propose possible steps to recover your funds.',
      consultationsSubtext: 'Your assets are important to us, and we will do everything we can to help you get them back!'
    },
    aboutPage: {
      welcomeTitle: 'WELCOME TO TRUSTBACK!',
      welcomeText: 'At TrustBack, we understand that losing cryptocurrency due to fraud is not just a financial loss but also an emotional shock. Our mission is to help you recover your stolen assets by offering reliable and effective fund recovery solutions.',
      teamTitle: 'OUR TEAM',
      teamText1: 'Being a hugely successful operator in the scam debt recovery field has led us to have a great many enemies in the criminal world of financial scams. To protect our team, we cannot disclose the names and identities of those who provide invaluable assistance.',
      teamText2: 'Among our team, we have a selection of key personnel who ensure the running of our operation is highly efficient and customer orientated.',
      teamText3: 'From Customer Support to Lawyers & Forensic Accountants, anyone you reach within our company is ideally placed to assist you.',
      resultTitle: 'OUR RESULT',
      resultText1: 'We are the largest recovery company worldwide and have been in operation since 2010. We have recovered tens of millions of dollars for thousands of clients.',
      resultText2: 'Furthermore, Trust Back is one of the few debt recovery services that successfully recover money from cryptocurrency scams.',
      resultAmount: '$78,450,883',
      resultSubtext: 'Successfully Recovered for Our Clients Since 2021',
      whyTitle: 'WHY CHOOSE US?',
      professionalism: 'Professionalism',
      professionalismDesc: 'We operate based on transparent methods and principles, allowing us to achieve high success rates in fund recovery.',
      individualApproach: 'Individual Approach',
      individualApproachDesc: 'Every situation is unique, so we develop personalized strategies tailored to your circumstances.',
      confidentiality: 'Guaranteed Confidentiality',
      confidentialityDesc: 'We protect your data using modern technologies and ensure complete information security.',
      ongoingSupport: 'Ongoing Support',
      ongoingSupportDesc: 'Our team is always available, ready to answer your questions and provide assistance at every stage of the process.',
      getConsultation: 'Get a Free Consultation'
    },
    binaryPage: {
      title: 'Binary Options Trading Fraud Recovery',
      subtitle: 'Specialized assistance in recovering funds lost to binary options trading scams',
      whatIs: 'What is Binary Options Trading Fraud?',
      whatIsDesc: 'Binary options trading fraud involves scammers posing as legitimate brokers or trading platforms. They promise high returns with minimal risk, but in reality, they manipulate trades, refuse withdrawals, and ultimately steal investors\' money.',
      signs: 'Common Warning Signs:',
      sign1: 'Unsolicited contact from "brokers" or "account managers"',
      sign2: 'Promises of guaranteed returns or "risk-free" trading',
      sign3: 'Pressure to deposit more money quickly',
      sign4: 'Difficulty or inability to withdraw your funds',
      sign5: 'Unregulated platforms without proper licensing',
      sign6: 'Manipulated trading software showing fake profits',
      howWeHelp: 'How We Can Help:',
      howWeHelpDesc: 'Our team of experts specializes in binary options fraud recovery. We investigate the fraudulent platform, gather evidence of misconduct, and work with financial institutions and regulatory bodies to recover your stolen funds.',
      successTitle: 'Our Success Rate',
      successDesc: 'We have achieved a high success rate in recovering funds from binary options scams, with an average recovery of 70-85% of lost funds for our clients.',
      cta: 'Start Your Recovery Process'
    },
    cryptoPage: {
      title: 'Cryptocurrency Fraud Recovery',
      subtitle: 'Expert recovery services for stolen cryptocurrency and digital assets',
      whatIs: 'Cryptocurrency Scams We Handle',
      whatIsDesc: 'Cryptocurrency fraud has become increasingly sophisticated. From fake exchanges to Ponzi schemes, scammers are constantly finding new ways to steal digital assets. Our team specializes in blockchain forensics and crypto recovery.',
      signs: 'Types of Crypto Fraud:',
      sign1: 'Fake cryptocurrency exchanges and wallet services',
      sign2: 'Investment scams and Ponzi schemes (e.g., cloud mining)',
      sign3: 'Phishing attacks targeting wallet credentials',
      sign4: 'Fraudulent ICOs and token sales',
      sign5: 'Social media impersonation scams',
      sign6: 'Romance scams involving cryptocurrency',
      sign7: 'Ransomware and extortion',
      howWeHelp: 'Our Recovery Process:',
      howWeHelpDesc: 'Using advanced blockchain analysis tools, we trace the movement of your stolen cryptocurrency. We work with exchanges, law enforcement, and legal experts to freeze assets and initiate recovery proceedings.',
      successTitle: 'Act Fast for Best Results',
      successDesc: 'Time is critical in cryptocurrency fraud cases. The sooner you contact us, the better the chances of recovering your assets before they\'re laundered or converted.',
      cta: 'Get Free Consultation'
    },
    forexPage: {
      title: 'Forex Trading Fraud Recovery',
      subtitle: 'Recover your funds from fraudulent Forex brokers and trading platforms',
      whatIs: 'Understanding Forex Trading Scams',
      whatIsDesc: 'Forex (foreign exchange) trading fraud is one of the most common forms of investment fraud. Scammers operate fake brokerages, manipulate trading platforms, and use various tactics to steal money from traders.',
      signs: 'Red Flags of Forex Scams:',
      sign1: 'Unregulated brokers without proper licensing',
      sign2: 'Guaranteed profits or "no-risk" trading promises',
      sign3: 'High-pressure sales tactics and bonus schemes',
      sign4: 'Inability to withdraw profits or original investment',
      sign5: 'Suspicious trading platform behavior or price manipulation',
      sign6: 'Account managers pushing aggressive trading strategies',
      sign7: 'Requests for additional deposits to "unlock" withdrawals',
      howWeHelp: 'Our Recovery Approach:',
      howWeHelpDesc: 'We have extensive experience dealing with Forex fraud cases. Our team investigates the broker, verifies regulatory violations, and works with payment processors and banks to initiate chargebacks.',
      successTitle: 'Expert Forex Recovery Team',
      successDesc: 'Our specialists have recovered over $25 million from Forex scams. We understand the complex international nature of these frauds and know how to navigate the recovery process effectively.',
      cta: 'Start Recovery Process'
    },
    romancePage: {
      title: 'Romance Scam Recovery',
      subtitle: 'Compassionate support for victims of romance and dating fraud',
      whatIs: 'Romance and Dating Scams',
      whatIsDesc: 'Romance scams are emotionally devastating and financially destructive. Scammers create fake profiles on dating sites or social media, build relationships with victims, and eventually request money for various fabricated emergencies.',
      signs: 'Common Romance Scam Tactics:',
      sign1: 'Fake profiles with stolen photos and fabricated identities',
      sign2: 'Quick professions of love and future plans together',
      sign3: 'Always having excuses not to meet in person or video call',
      sign4: 'Requests for money for emergencies, travel, or business',
      sign5: 'Investment opportunities in cryptocurrency or forex',
      sign6: 'Asking for gift cards, wire transfers, or cryptocurrency payments',
      sign7: 'Stories involving military service, overseas work, or family crises',
      howWeHelp: "We're Here to Help:",
      howWeHelpDesc: 'We understand the emotional toll of romance scams. Our team handles these cases with sensitivity and discretion while aggressively pursuing fund recovery.',
      successTitle: 'Confidential & Compassionate Service',
      successDesc: "We treat all romance scam cases with complete confidentiality and understanding. You're not alone, and there's no shame in seeking help.",
      cta: 'Get Confidential Consultation'
    },
    propertyPage: {
      title: 'Property Fraud Recovery',
      subtitle: 'Specialized assistance for real estate and property investment fraud victims',
      whatIs: 'Real Estate and Property Scams',
      whatIsDesc: 'Property fraud involves scammers targeting people looking to buy, rent, or invest in real estate. These scams can result in significant financial losses and legal complications.',
      signs: 'Types of Property Fraud:',
      sign1: 'Fake rental listings and advance fee scams',
      sign2: 'Fraudulent property investment schemes',
      sign3: 'Title fraud and property deed manipulation',
      sign4: 'Off-plan property scams and non-existent developments',
      sign5: 'Fake real estate agents and companies',
      sign6: 'Timeshare and vacation property fraud',
      sign7: 'Foreclosure rescue scams',
      howWeHelp: 'Our Recovery Services:',
      howWeHelpDesc: 'We investigate property fraud cases thoroughly, working with real estate lawyers, title companies, and law enforcement.',
      successTitle: 'Protect Your Investment',
      successDesc: "Real estate fraud can be complex, but we have the expertise to navigate property law and recover your investment.",
      cta: 'Start Your Case'
    },
    creditCardPage: {
      title: 'Credit Card Phishing Recovery',
      subtitle: 'Help for victims of credit card fraud and phishing attacks',
      whatIs: 'Credit Card and Phishing Scams',
      whatIsDesc: 'Credit card phishing and fraud involve criminals stealing your payment information through fake websites, emails, or phone calls. They then use this information to make unauthorized purchases or drain your accounts.',
      signs: 'Common Phishing Methods:',
      sign1: 'Fake emails pretending to be from banks or payment services',
      sign2: 'Fraudulent websites mimicking legitimate businesses',
      sign3: 'Phone scams (vishing) claiming to be from your bank',
      sign4: 'SMS phishing (smishing) with fake security alerts',
      sign5: 'Social media scams and fake customer service accounts',
      sign6: 'Skimming devices on ATMs and payment terminals',
      sign7: 'Data breaches exposing card information',
      howWeHelp: 'How We Help:',
      howWeHelpDesc: 'We work with banks, credit card companies, and cybersecurity experts to investigate fraudulent transactions and navigate the chargeback process.',
      successTitle: 'Immediate Action Required',
      successDesc: "If you've been a victim of credit card fraud or phishing, time is critical. Contact us immediately to begin the dispute and recovery process.",
      cta: 'Get Immediate Help'
    },
    stockPage: {
      title: 'Stock Trading Fraud Recovery',
      subtitle: 'Expert assistance for victims of stock market and securities fraud',
      whatIs: 'Stock Trading and Investment Scams',
      whatIsDesc: 'Stock trading fraud includes various schemes targeting investors through fake brokerages, pump-and-dump schemes, insider trading scams, and fraudulent investment advisors.',
      signs: 'Types of Stock Fraud:',
      sign1: 'Pump-and-dump schemes artificially inflating stock prices',
      sign2: 'Fake online brokerages and trading platforms',
      sign3: 'Ponzi schemes disguised as investment funds',
      sign4: 'Fraudulent investment advisors and financial planners',
      sign5: 'High-yield investment programs (HYIP) scams',
      sign6: 'Advance fee fraud for "exclusive" investment opportunities',
      sign7: 'Unauthorized trading and churning by brokers',
      howWeHelp: 'Our Expertise:',
      howWeHelpDesc: 'Our team includes financial analysts and legal experts who specialize in securities fraud. We investigate fraudulent trading platforms and pursue recovery through legal channels.',
      successTitle: 'Recover Your Investment',
      successDesc: "Whether you've lost money to a fake brokerage or a pump-and-dump scheme, we have the expertise to help.",
      cta: 'Recover Your Funds'
    },
    otherPage: {
      title: 'Other Financial Fraud Recovery',
      subtitle: 'Comprehensive fraud recovery services for all types of financial scams',
      whatIs: 'We Handle All Types of Financial Fraud',
      whatIsDesc: "Beyond our specialized services, we assist victims of many other types of financial fraud. If you've been scammed and don't see your specific situation listed, we can still help.",
      signs: 'Other Fraud Types We Handle:',
      sign1: 'Online shopping and auction fraud',
      sign2: 'Employment and work-from-home scams',
      sign3: 'Lottery and prize scams',
      sign4: 'Tech support scams',
      sign5: 'Business email compromise (BEC)',
      sign6: 'Invoice fraud and payment redirection',
      sign7: 'Identity theft and synthetic identity fraud',
      howWeHelp: 'Our Comprehensive Approach:',
      howWeHelpDesc: 'No matter what type of fraud you\'ve experienced, our approach remains the same: thorough investigation, evidence gathering, and aggressive pursuit of your stolen funds.',
      successTitle: 'Not Sure If We Can Help?',
      successDesc: 'Even if your case seems unique or complex, reach out to us. Our free consultation will help determine if we can assist you in recovering your funds.',
      cta: 'Discuss Your Case'
    },
    regulationsPage: {
      euMicaTitle: 'EU MICA',
      euMicaSubtitle: '(MARKETS IN CRYPTO-ASSETS REGULATION)',
      euMica1: 'Requires mandatory licensing for crypto-asset service providers (CASPs).',
      euMica2: 'Enforces capital requirements, insurance policies, and reserve mechanisms to ensure solvency.',
      euMica3: 'Strong consumer protection standards: transparent risk disclosures, clear service terms, and anti-fraud measures.',
      euMica4: 'Pan-European harmonization \u2014 unified rules across all EU member states under ESMA and EBA supervision.',
      auApraTitle: 'AU APRA',
      auApraSubtitle: '(AUSTRALIAN PRUDENTIAL REGULATION AUTHORITY)',
      auApra1: 'Oversees banks, insurers, and pension funds.',
      auApra2: 'Imposes capital adequacy and risk assessment requirements related to crypto-asset exposure.',
      auApra3: 'Requires stress testing and management of third-party risks.',
      auAsicTitle: 'AU ASIC',
      auAsicSubtitle: '(AUSTRALIAN SECURITIES AND INVESTMENTS COMMISSION)',
      auAsicIntro: 'Regulates crypto services as financial products:',
      auAsic1: 'Requires an AFSL (Australian Financial Services Licence)',
      auAsic2: 'Enforces custody standards, fair pricing, and audit rules for crypto ETFs and asset managers.',
      caTitle: 'CA CANADIAN REGULATORY FRAMEWORK',
      caOsfi: 'OSFI \u2014 Supervises banks and insurers, ensuring deposit protection and capital stability.',
      caIiroc: 'IIROC \u2014 Regulates investment brokers and traders, ensuring transparency and client protection.',
      caCsa: 'CSA (via provincial regulators) \u2014 Requires crypto platforms to:',
      caCsa1: 'Register and disclose risks',
      caCsa2: 'Undergo regular audits and maintain robust security practices',
      caCsa3: 'Segregate client funds',
      usSecTitle: 'US SEC',
      usSecDesc: 'The Securities and Exchange Commission regulates crypto securities and enforces investor protection laws in the United States.',
      ukFcaTitle: 'UK FCA',
      ukFcaDesc: 'The Financial Conduct Authority oversees crypto-asset businesses, requiring registration and compliance with anti-money laundering regulations.'
    },
    privacyPage: {
      title: 'Privacy Policy',
      subtitle: 'Your privacy is important to us',
      intro1: 'Your privacy is important to us. It is TrustBack\'s policy to respect your privacy regarding any information we may collect from you across our website, trustback.eu, and other sites we own and operate.',
      intro2: 'We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent.',
      intro3: 'We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we\'ll protect within commercially acceptable means to prevent loss and theft.',
      intro4: 'We don\'t share any personally identifying information publicly or with third-parties, except when required to by law.',
      intro5: 'Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites.',
      intro6: 'You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.',
      overviewTitle: 'Overview',
      overviewText1: 'This website uses cookies to improve your experience while you navigate through the website. The cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities.',
      overviewText2: 'We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent.',
      cookieTitle: 'Cookie Policy',
      cookieText1: 'Like most websites, our websites use cookies to collect information. Cookies are small data files which are placed on your computer or other devices as you browse our websites.',
      cookieText2: 'Cookies are essential for the effective operation of our website and to help us further advertise our services.',
      infoTitle: 'Information Collected',
      infoText1: 'Some cookies collect information about browsing when you access our websites via the same computer or device.',
      infoText2: 'All data passed by cookies is anonymous and will never contain individual detail such as your name, address or telephone number.',
      managedTitle: 'How Are Cookies Managed',
      managedText: 'The cookies stored on your computer or other device when you access our websites are designed by:',
      managed1: 'Third parties who participate with us in marketing programmes; and',
      managed2: 'Third parties who participate with us in marketing programmes',
      usedTitle: 'What Are Cookies Used For?',
      usedText: 'The main purposes for which cookies are used are:',
      used1: 'For functional purposes essential to effective operation of our website.',
      used2: 'For marketing and advertising, particularly web banner advertisements and targeted updates.',
      used3: 'For website analytics purposes, particularly services by Google such as Google Analytics.',
      gaNotice1: 'By using this website, you consent to the processing of data about you by Google in the manner described in Google\'s Privacy Policy.',
      gaNotice2: 'You can opt out of Google Analytics if you disable or refuse the cookie, disable JavaScript, or use the opt-out service provided by Google.',
      contactText: 'If you have any questions about how we handle user data and personal information, feel free to'
    },
    cookie: {
      message: 'We use cookies to improve your experience on our website. By continuing to browse, you agree to our use of cookies.',
      accept: 'Accept All',
      decline: 'Decline',
      learnMore: 'Learn More'
    },
    footer: {
      description: 'We help victims of financial scams recover their stolen money. With years of experience in legal, crypto, and banking investigations.',
      quickLinks: 'Quick Links',
      contact: 'Contact Us',
      infoLine: 'Info line',
      consultationLine: 'Consultation with a specialist',
      headOffice: 'Head Office: 6 Pl. de la Pyramide, 92800 Puteaux, France \u2014 in-person and online support.',
      polishBranch: 'Polish Branch: ul. Suwalska 25/27, 93-176 \u0141\u00F3d\u017A \u2014 online support only.',
      complianceNote: '(Shift to online service due to compliance with EU MiCA regulations and Polish AML legislation).',
      rights: 'All rights reserved.'
    }
  },
  pl: {
    nav: {
      pages: 'Strony',
      contacts: 'Kontakt',
      regulations: 'Regulamin',
      aboutUs: 'O nas',
      login: 'Logowanie',
      freeConsultation: 'Darmowa konsultacja',
      home: 'Strona g\u0142\u00F3wna',
      privacyPolicy: 'Polityka prywatno\u015Bci'
    },
    hero: {
      title: 'Odzyskaj swoje pieni\u0105dze od oszust\u00F3w',
      subtitle: 'Je\u015Bli pad\u0142e\u015B ofiar\u0105 oszuka\u0144czych firm, skontaktuj si\u0119 z naszym zespo\u0142em ekspert\u00F3w, a pomog\u0105 Ci odzyska\u0107 wszystko',
      formTitle: 'Formularz darmowej konsultacji',
      name: 'Imi\u0119 i nazwisko',
      namePlaceholder: 'Wprowad\u017A swoje imi\u0119',
      email: 'Adres e-mail',
      emailPlaceholder: 'twoj@email.com',
      phone: 'Numer telefonu',
      phonePlaceholder: 'Numer telefonu',
      amountLost: 'Ile straci\u0142e\u015B?',
      amountPlaceholder: 'Wybierz zakres kwoty',
      message: 'Opowiedz nam o swojej sytuacji (opcjonalnie)',
      messagePlaceholder: 'Kr\u00F3tko opisz, co si\u0119 sta\u0142o...',
      submit: 'UZYSKAJ DARMOW\u0104 KONSULTACJ\u0118',
      submitting: 'WYSY\u0141ANIE...'
    },
    amounts: {
      'less-5000': 'Mniej ni\u017C 5 000 $',
      '5000-10000': '5 000 $ \u2013 10 000 $',
      '10000-20000': '10 000 $ \u2013 20 000 $',
      '20000-40000': '20 000 $ \u2013 40 000 $',
      '40000-80000': '40 000 $ \u2013 80 000 $',
      '80000-160000': '80 000 $ \u2013 160 000 $',
      '160000-plus': '160 000 $ i wi\u0119cej'
    },
    regulatory: {
      text: 'Wszystkie dzia\u0142ania podejmowane przez nasz\u0105 firm\u0119 s\u0105 prowadzone pod nadzorem i kierunkiem nast\u0119puj\u0105cych organ\u00F3w regulacyjnych i partner\u00F3w.'
    },
    howItWorks: {
      title: 'Jak to dzia\u0142a',
      step1Title: 'Przegl\u0105d sprawy',
      step1Desc: 'Przeprowadzamy wst\u0119pne kontrole, aby oceni\u0107, czy sprawa mo\u017Ce zako\u0144czy\u0107 si\u0119 znacz\u0105cym odzyskaniem.',
      step2Title: 'Zbieranie dowod\u00F3w',
      step2Desc: 'Zbieramy wszystkie informacje i dokumentacj\u0119 wymagan\u0105 do pomy\u015Blnego prowadzenia Twojej sprawy.',
      step3Title: 'Konfrontacja z podmiotami',
      step3Desc: 'Systematycznie konfrontujemy odpowiednie podmioty, kt\u00F3re u\u0142atwi\u0142y nielegalny transfer Twojego maj\u0105tku.',
      step4Title: 'Odzyskaj swoje pieni\u0105dze',
      step4Desc: 'Jeste\u015Bmy dumni z naszych osi\u0105gni\u0119\u0107 i zapewniamy, \u017Ce zrobimy wszystko, aby odzyska\u0107 Twoje pieni\u0105dze.'
    },
    moneyRetrieved: {
      title: 'Pieni\u0105dze odzyskane w latach 2021-2026',
      subtitle: 'Nasz zesp\u00F3\u0142 ekspert\u00F3w codziennie zabezpiecza zwroty. Pomagamy firmom oraz osobom prywatnym w d\u0105\u017Ceniu do odzyskania \u015Brodk\u00F3w utraconych na rzecz oszust\u00F3w.',
      amount: '78 450 883 $',
      subtext: 'Pomy\u015Blnie odzyskane dla naszych klient\u00F3w',
      button: 'Uzyskaj darmow\u0105 konsultacj\u0119'
    },
    whyUs: {
      title1: 'Dlaczego warto z nami wsp\u00F3\u0142pracowa\u0107?',
      desc1: 'Kr\u00F3tka odpowied\u017A: Przyjmujemy tylko sprawy, kt\u00F3re naszym zdaniem mog\u0105 zako\u0144czy\u0107 si\u0119 znacz\u0105cym odzyskaniem. Tw\u00F3j czas jest r\u00F3wnie cenny jak nasz, dlatego jeste\u015Bmy ca\u0142kowicie przejrzy\u015Bci w ocenie ka\u017Cdej sprawy.',
      title2: 'Gwarancja zwrotu pieni\u0119dzy',
      desc2: 'Proces odzyskiwania \u015Brodk\u00F3w mo\u017Ce by\u0107 d\u0142ugotrwa\u0142y i wymaga wytrwa\u0142o\u015Bci. Je\u015Bli z jakiegokolwiek powodu masz w\u0105tpliwo\u015Bci, mo\u017Cesz poprosi\u0107 o pe\u0142ny zwrot w ci\u0105gu pierwszych 14 dni roboczych procesu.'
    },
    services: {
      title: 'Us\u0142ugi odzyskiwania po oszustwach',
      subtitle: 'Specjalizujemy si\u0119 w odzyskiwaniu \u015Brodk\u00F3w utraconych w wyniku r\u00F3\u017Cnych rodzaj\u00F3w oszustw finansowych',
      howWeWork: 'Jak pracujemy, aby odzyska\u0107 pieni\u0105dze naszych klient\u00F3w',
      howWeWorkDesc: 'Po pierwsze, nasz zesp\u00F3\u0142 ekspert\u00F3w finansowych zabezpiecza odpowiednie informacje od Ciebie, ofiary oszustwa. Nast\u0119pnie nasi specjali\u015Bci ds. odzyskiwania i dzia\u0142 prawny tropi\u0105 i konfrontuj\u0105 oszust\u00F3w.',
      getConsultation: 'Uzyskaj darmow\u0105 konsultacj\u0119',
      binaryOptions: 'Handel opcjami binarnymi',
      cryptocurrency: 'Kryptowaluty',
      forex: 'Forex',
      romance: 'Oszustwa romansowe',
      property: 'Nieruchomo\u015Bci',
      creditCard: 'Phishing kart kredytowych',
      stockTrading: 'Handel akcjami',
      other: 'Inne'
    },
    team: {
      title: 'Nasz zesp\u00F3\u0142',
      subtitle: 'Poznaj nasz oddany zesp\u00F3\u0142 profesjonalist\u00F3w specjalizuj\u0105cych si\u0119 w odzyskiwaniu skradzionych kryptowalut i funduszy.'
    },
    about: {
      sectionTitle: 'Wi\u0119cej o Trust Back i bran\u017Cy chargeback',
      accordion1Title: 'Dowiedz si\u0119 wi\u0119cej o Trust Back i bran\u017Cy chargeback',
      accordion1Text1: 'Oszustwa internetowe s\u0105 powszechne w\u015Br\u00F3d nielegalnych sklep\u00F3w i sprzedawc\u00F3w w internecie.',
      accordion1Text2: 'Na przyk\u0142ad, istnieje wiele rynk\u00F3w online i trader\u00F3w, kt\u00F3rzy mog\u0105 \u0142atwo oszuka\u0107 ludzi, podszywaj\u0105c si\u0119 pod legalny podmiot.',
      accordion2Title: 'Bran\u017Ca chargeback',
      accordion2Text1: 'Chargeback to proces sk\u0142adania wniosku o zwrot \u015Brodk\u00F3w przez klienta w banku.',
      accordion2Text2: 'Zamiast konwencjonalnego sposobu proszenia o zwrot pieni\u0119dzy, metoda chargeback zwraca si\u0119 bezpo\u015Brednio do banku o zwrot.',
      accordion3Title: 'Odzyskiwanie \u015Brodk\u00F3w z Trust Back',
      accordion3Text1: 'Trust Back oferuje tego rodzaju us\u0142ug\u0119 z ekspertami ds. odzyskiwania maj\u0105tku i specjalistami ds. odzyskiwania funduszy.',
      accordion3Text2: 'Jest to us\u0142uga wykorzystywana przez ofiary oszustw internetowych do odzyskania pieni\u0119dzy od fa\u0142szywych sprzedawc\u00F3w.',
      accordion4Title: 'Odzyskaj \u015Brodki po oszustwach handlowych online',
      accordion4Q1: 'Jak mog\u0119 odzyska\u0107 utracone pieni\u0105dze z Forex?',
      accordion4Q2: 'Jak odzyska\u0107 straty handlowe?',
      accordion4Text1: 'Te pytania nurtuj\u0105 tych, kt\u00F3rzy padli ofiar\u0105 oszustw handlowych online. Jednak z Trust Back szybkie odzyskanie pieni\u0119dzy nie stanowi problemu.',
      accordion4Text2: 'Oszustwa w handlu online s\u0105 powi\u0105zane z oszustwami inwestycyjnymi.',
      accordion5Title: 'O Trust Back',
      accordion5Text1: 'Trust Back ma jedn\u0105 misj\u0119: chroni\u0107 ludzi przed oszustwami online na ca\u0142ym \u015Bwiecie.',
      accordion5Text2: 'Nasz zesp\u00F3\u0142 sk\u0142ada si\u0119 z wykwalifikowanych ekspert\u00F3w i profesjonalist\u00F3w z wieloletnim do\u015Bwiadczeniem.',
      accordion5Text3: 'Je\u015Bli zosta\u0142e\u015B oszukany, masz prawo odzyska\u0107 to, co straci\u0142e\u015B.'
    },
    contacts: {
      title: 'Kontakt',
      heroText: 'Je\u015Bli pad\u0142e\u015B ofiar\u0105 oszustwa i chcesz odzyska\u0107 swoje \u015Brodki, nasz zesp\u00F3\u0142 jest gotowy Ci pom\u00F3c.',
      getConsultation: 'UZYSKAJ DARMOW\u0104 KONSULTACJ\u0118',
      franceOffice: 'Biuro we Francji',
      polandOffice: 'Biuro w Polsce',
      consultationsTitle: 'Konsultacje',
      consultationsText: 'Oferujemy bezp\u0142atn\u0105 wst\u0119pn\u0105 konsultacj\u0119, podczas kt\u00F3rej ocenimy Twoj\u0105 sytuacj\u0119 i zaproponujemy mo\u017Cliwe kroki w celu odzyskania Twoich \u015Brodk\u00F3w.',
      consultationsSubtext: 'Twoje aktywa s\u0105 dla nas wa\u017Cne i zrobimy wszystko, co w naszej mocy, aby pom\u00F3c Ci je odzyska\u0107!'
    },
    aboutPage: {
      welcomeTitle: 'WITAMY W TRUSTBACK!',
      welcomeText: 'W TrustBack rozumiemy, \u017Ce utrata kryptowalut w wyniku oszustwa to nie tylko strata finansowa, ale tak\u017Ce szok emocjonalny. Nasz\u0105 misj\u0105 jest pomoc w odzyskaniu skradzionych aktyw\u00F3w.',
      teamTitle: 'NASZ ZESP\u00D3\u0141',
      teamText1: 'B\u0119d\u0105c odnosz\u0105cym sukcesy operatorem w dziedzinie odzyskiwania d\u0142ug\u00F3w po oszustwach, zyskali\u015Bmy wielu wrog\u00F3w w \u015Bwiecie przest\u0119pczo\u015Bci finansowej.',
      teamText2: 'W naszym zespole mamy wyb\u00F3r kluczowego personelu, kt\u00F3ry zapewnia wysoce wydajne i zorientowane na klienta dzia\u0142anie naszej firmy.',
      teamText3: 'Od obs\u0142ugi klienta po prawnik\u00F3w i ksi\u0119gowych s\u0105dowych \u2013 ka\u017Cdy w naszej firmie jest idealnie przygotowany, aby Ci pom\u00F3c.',
      resultTitle: 'NASZE WYNIKI',
      resultText1: 'Jeste\u015Bmy najwi\u0119ksz\u0105 firm\u0105 odzyskuj\u0105c\u0105 \u015Brodki na \u015Bwiecie i dzia\u0142amy od 2010 roku.',
      resultText2: 'Ponadto Trust Back jest jedn\u0105 z niewielu us\u0142ug skutecznie odzyskuj\u0105cych pieni\u0105dze z oszustw kryptowalutowych.',
      resultAmount: '78 450 883 $',
      resultSubtext: 'Pomy\u015Blnie odzyskane dla naszych klient\u00F3w od 2021',
      whyTitle: 'DLACZEGO MY?',
      professionalism: 'Profesjonalizm',
      professionalismDesc: 'Dzia\u0142amy w oparciu o przejrzyste metody i zasady, co pozwala nam osi\u0105ga\u0107 wysokie wska\u017Aniki sukcesu.',
      individualApproach: 'Indywidualne podej\u015Bcie',
      individualApproachDesc: 'Ka\u017Cda sytuacja jest wyj\u0105tkowa, dlatego opracowujemy spersonalizowane strategie.',
      confidentiality: 'Gwarantowana poufno\u015B\u0107',
      confidentialityDesc: 'Chronimy Twoje dane za pomoc\u0105 nowoczesnych technologii i zapewniamy pe\u0142ne bezpiecze\u0144stwo informacji.',
      ongoingSupport: 'Sta\u0142e wsparcie',
      ongoingSupportDesc: 'Nasz zesp\u00F3\u0142 jest zawsze dost\u0119pny, gotowy odpowiedzie\u0107 na Twoje pytania na ka\u017Cdym etapie procesu.',
      getConsultation: 'Uzyskaj darmow\u0105 konsultacj\u0119'
    },
    binaryPage: {
      title: 'Odzyskiwanie po oszustwach z opcjami binarnymi',
      subtitle: 'Specjalistyczna pomoc w odzyskiwaniu \u015Brodk\u00F3w utraconych w wyniku oszustw z opcjami binarnymi',
      whatIs: 'Czym s\u0105 oszustwa z opcjami binarnymi?',
      whatIsDesc: 'Oszustwa z opcjami binarnymi polegaj\u0105 na podszywaniu si\u0119 oszust\u00F3w pod legalnych broker\u00F3w lub platformy handlowe. Obiecuj\u0105 wysokie zwroty przy minimalnym ryzyku, ale w rzeczywisto\u015Bci manipuluj\u0105 transakcjami i kradn\u0105 pieni\u0105dze inwestor\u00F3w.',
      signs: 'Typowe znaki ostrzegawcze:',
      sign1: 'Niezam\u00F3wiony kontakt od \u201Ebroker\u00F3w\u201D lub \u201Eopiekun\u00F3w konta\u201D',
      sign2: 'Obietnice gwarantowanych zysk\u00F3w lub handlu \u201Ebez ryzyka\u201D',
      sign3: 'Nacisk na szybkie wp\u0142acenie wi\u0119kszych \u015Brodk\u00F3w',
      sign4: 'Trudno\u015Bci lub niemo\u017Cno\u015B\u0107 wyp\u0142aty \u015Brodk\u00F3w',
      sign5: 'Nieregulowane platformy bez odpowiednich licencji',
      sign6: 'Zmanipulowane oprogramowanie handlowe pokazuj\u0105ce fa\u0142szywe zyski',
      howWeHelp: 'Jak mo\u017Cemy pom\u00F3c:',
      howWeHelpDesc: 'Nasz zesp\u00F3\u0142 specjalizuje si\u0119 w odzyskiwaniu \u015Brodk\u00F3w z oszustw z opcjami binarnymi. Badamy oszuka\u0144cz\u0105 platform\u0119, zbieramy dowody i wsp\u00F3\u0142pracujemy z instytucjami finansowymi.',
      successTitle: 'Nasz wska\u017Anik sukcesu',
      successDesc: 'Osi\u0105gn\u0119li\u015Bmy wysoki wska\u017Anik sukcesu w odzyskiwaniu \u015Brodk\u00F3w z oszustw z opcjami binarnymi, ze \u015Brednim odzyskaniem 70-85% utraconych \u015Brodk\u00F3w.',
      cta: 'Rozpocznij proces odzyskiwania'
    },
    cryptoPage: {
      title: 'Odzyskiwanie po oszustwach kryptowalutowych',
      subtitle: 'Ekspertyza w odzyskiwaniu skradzionych kryptowalut i aktyw\u00F3w cyfrowych',
      whatIs: 'Oszustwa kryptowalutowe, kt\u00F3rymi si\u0119 zajmujemy',
      whatIsDesc: 'Oszustwa kryptowalutowe staj\u0105 si\u0119 coraz bardziej wyrafinowane. Od fa\u0142szywych gie\u0142d po piramidy finansowe, oszustwa ci\u0105gle znajduj\u0105 nowe sposoby na kradzie\u017C aktyw\u00F3w cyfrowych.',
      signs: 'Rodzaje oszustw kryptowalutowych:',
      sign1: 'Fa\u0142szywe gie\u0142dy kryptowalut i us\u0142ugi portfeli',
      sign2: 'Oszustwa inwestycyjne i piramidy finansowe',
      sign3: 'Ataki phishingowe na dane logowania do portfeli',
      sign4: 'Oszuka\u0144cze ICO i sprzeda\u017C token\u00F3w',
      sign5: 'Oszustwa polegaj\u0105ce na podszywaniu si\u0119 w mediach spo\u0142eczno\u015Bciowych',
      sign6: 'Oszustwa romansowe z wykorzystaniem kryptowalut',
      sign7: 'Ransomware i wymuszenia',
      howWeHelp: 'Nasz proces odzyskiwania:',
      howWeHelpDesc: 'Za pomoc\u0105 zaawansowanych narz\u0119dzi analizy blockchain \u015Bledzimy ruch skradzionych kryptowalut. Wsp\u00F3\u0142pracujemy z gie\u0142dami, organami \u015Bcigania i ekspertami prawnymi.',
      successTitle: 'Dzia\u0142aj szybko, aby uzyska\u0107 najlepsze wyniki',
      successDesc: 'Czas jest kluczowy w przypadkach oszustw kryptowalutowych. Im szybciej si\u0119 z nami skontaktujesz, tym lepsze szanse na odzyskanie aktyw\u00F3w.',
      cta: 'Uzyskaj darmow\u0105 konsultacj\u0119'
    },
    forexPage: {
      title: 'Odzyskiwanie po oszustwach Forex',
      subtitle: 'Odzyskaj swoje \u015Brodki od oszuka\u0144czych broker\u00F3w Forex',
      whatIs: 'Zrozumienie oszustw Forex',
      whatIsDesc: 'Oszustwa Forex to jedna z najcz\u0119stszych form oszustw inwestycyjnych. Oszustwa prowadz\u0105 fa\u0142szywe domy maklerskie i manipuluj\u0105 platformami handlowymi.',
      signs: 'Sygna\u0142y ostrzegawcze oszustw Forex:',
      sign1: 'Nieregulowani brokerzy bez odpowiednich licencji',
      sign2: 'Gwarantowane zyski lub obietnice handlu \u201Ebez ryzyka\u201D',
      sign3: 'Agresywne taktyki sprzeda\u017Cy i systemy bonus\u00F3w',
      sign4: 'Niemo\u017Cno\u015B\u0107 wyp\u0142aty zysk\u00F3w lub pierwotnej inwestycji',
      sign5: 'Podejrzane zachowanie platformy handlowej lub manipulacja cenami',
      sign6: 'Opiekunowie konta forsuj\u0105cy agresywne strategie handlowe',
      sign7: '\u017B\u0105dania dodatkowych wp\u0142at w celu \u201Eodblokowania\u201D wyp\u0142at',
      howWeHelp: 'Nasze podej\u015Bcie do odzyskiwania:',
      howWeHelpDesc: 'Mamy bogate do\u015Bwiadczenie w sprawach oszustw Forex. Nasz zesp\u00F3\u0142 bada brokera, weryfikuje naruszenia regulacyjne i wsp\u00F3\u0142pracuje z procesorami p\u0142atno\u015Bci.',
      successTitle: 'Eksperci ds. odzyskiwania Forex',
      successDesc: 'Nasi specjali\u015Bci odzyskali ponad 25 milion\u00F3w dolar\u00F3w z oszustw Forex.',
      cta: 'Rozpocznij proces odzyskiwania'
    },
    romancePage: {
      title: 'Odzyskiwanie po oszustwach romansowych',
      subtitle: 'Wsp\u00F3\u0142czuj\u0105ce wsparcie dla ofiar oszustw romansowych i matrymonialnych',
      whatIs: 'Oszustwa romansowe i matrymonialne',
      whatIsDesc: 'Oszustwa romansowe s\u0105 emocjonalnie niszcz\u0105ce i finansowo destrukcyjne. Oszustwa tworz\u0105 fa\u0142szywe profile na portalach randkowych i wyci\u0105gaj\u0105 pieni\u0105dze pod r\u00F3\u017Cnymi pretekstami.',
      signs: 'Typowe taktyki oszustw romansowych:',
      sign1: 'Fa\u0142szywe profile ze skradzionymi zdj\u0119ciami',
      sign2: 'Szybkie wyznania mi\u0142osne i plany na przysz\u0142o\u015B\u0107',
      sign3: 'Zawsze maj\u0105 wym\u00F3wki, aby nie spotka\u0107 si\u0119 osobi\u015Bcie',
      sign4: 'Pro\u015Bby o pieni\u0105dze na nag\u0142e wypadki, podr\u00F3\u017Ce lub biznes',
      sign5: 'Mo\u017Cliwo\u015Bci inwestycyjne w kryptowaluty lub forex',
      sign6: 'Proszenie o karty podarunkowe, przelewy lub p\u0142atno\u015Bci kryptowalutowe',
      sign7: 'Historie dotycz\u0105ce s\u0142u\u017Cby wojskowej, pracy za granic\u0105 lub kryzysu rodzinnego',
      howWeHelp: 'Jeste\u015Bmy tu, aby pom\u00F3c:',
      howWeHelpDesc: 'Rozumiemy emocjonalne obci\u0105\u017Cenie zwi\u0105zane z oszustwami romansowymi. Nasz zesp\u00F3\u0142 zajmuje si\u0119 tymi sprawami z wra\u017Cliwo\u015Bci\u0105 i dyskrecj\u0105.',
      successTitle: 'Poufna i wsp\u00F3\u0142czuj\u0105ca obs\u0142uga',
      successDesc: 'Wszystkie sprawy oszustw romansowych traktujemy z pe\u0142n\u0105 poufno\u015Bci\u0105 i zrozumieniem. Nie jeste\u015B sam/sama.',
      cta: 'Uzyskaj poufn\u0105 konsultacj\u0119'
    },
    propertyPage: {
      title: 'Odzyskiwanie po oszustwach nieruchomo\u015Bciowych',
      subtitle: 'Specjalistyczna pomoc dla ofiar oszustw zwi\u0105zanych z nieruchomo\u015Bciami i inwestycjami',
      whatIs: 'Oszustwa nieruchomo\u015Bciowe',
      whatIsDesc: 'Oszustwa nieruchomo\u015Bciowe dotycz\u0105 os\u00F3b szukaj\u0105cych kupna, wynajmu lub inwestycji w nieruchomo\u015Bci. Mog\u0105 prowadzi\u0107 do znacznych strat finansowych.',
      signs: 'Rodzaje oszustw nieruchomo\u015Bciowych:',
      sign1: 'Fa\u0142szywe og\u0142oszenia wynajmu i oszustwa z zaliaczkami',
      sign2: 'Oszuka\u0144cze schematy inwestycji w nieruchomo\u015Bci',
      sign3: 'Oszustwa tytu\u0142owe i manipulacja aktami w\u0142asno\u015Bci',
      sign4: 'Oszustwa z nieruchomo\u015Bciami w budowie',
      sign5: 'Fa\u0142szywi agenci nieruchomo\u015Bci i firmy',
      sign6: 'Oszustwa z timeshare i nieruchomo\u015Bciami wakacyjnymi',
      sign7: 'Oszustwa zwi\u0105zane z ratowaniem przed przej\u0119ciem nieruchomo\u015Bci',
      howWeHelp: 'Nasze us\u0142ugi odzyskiwania:',
      howWeHelpDesc: 'Dok\u0142adnie badamy sprawy oszustw nieruchomo\u015Bciowych, wsp\u00F3\u0142pracuj\u0105c z prawnikami ds. nieruchomo\u015Bci i organami \u015Bcigania.',
      successTitle: 'Chro\u0144 swoj\u0105 inwestycj\u0119',
      successDesc: 'Oszustwa nieruchomo\u015Bciowe mog\u0105 by\u0107 skomplikowane, ale mamy wiedz\u0119, aby odzyska\u0107 Twoj\u0105 inwestycj\u0119.',
      cta: 'Rozpocznij swoj\u0105 spraw\u0119'
    },
    creditCardPage: {
      title: 'Odzyskiwanie po phishingu kart kredytowych',
      subtitle: 'Pomoc dla ofiar oszustw kart kredytowych i atak\u00F3w phishingowych',
      whatIs: 'Oszustwa z kartami kredytowymi i phishing',
      whatIsDesc: 'Phishing i oszustwa z kartami kredytowymi polegaj\u0105 na kradzie\u017Cy danych p\u0142atniczych przez fa\u0142szywe strony, e-maile lub telefony.',
      signs: 'Typowe metody phishingu:',
      sign1: 'Fa\u0142szywe e-maile podszywaj\u0105ce si\u0119 pod banki lub serwisy p\u0142atnicze',
      sign2: 'Oszuka\u0144cze strony internetowe imituj\u0105ce legalne firmy',
      sign3: 'Oszustwa telefoniczne (vishing) podszywaj\u0105ce si\u0119 pod bank',
      sign4: 'Phishing SMS (smishing) z fa\u0142szywymi alertami bezpiecze\u0144stwa',
      sign5: 'Oszustwa w mediach spo\u0142eczno\u015Bciowych i fa\u0142szywe konta obs\u0142ugi klienta',
      sign6: 'Urz\u0105dzenia skimmingowe na bankomatach i terminalach p\u0142atniczych',
      sign7: 'Naruszenia danych ujawniaj\u0105ce informacje o kartach',
      howWeHelp: 'Jak pomagamy:',
      howWeHelpDesc: 'Wsp\u00F3\u0142pracujemy z bankami, firmami kart kredytowych i ekspertami ds. cyberbezpiecze\u0144stwa w celu zbadania oszuka\u0144czych transakcji.',
      successTitle: 'Wymagane natychmiastowe dzia\u0142anie',
      successDesc: 'Je\u015Bli pad\u0142e\u015B ofiar\u0105 oszustwa kart\u0105 kredytow\u0105, czas jest kluczowy. Skontaktuj si\u0119 z nami natychmiast.',
      cta: 'Uzyskaj natychmiastow\u0105 pomoc'
    },
    stockPage: {
      title: 'Odzyskiwanie po oszustwach gie\u0142dowych',
      subtitle: 'Ekspercka pomoc dla ofiar oszustw na gie\u0142dzie papier\u00F3w warto\u015Bciowych',
      whatIs: 'Oszustwa gie\u0142dowe i inwestycyjne',
      whatIsDesc: 'Oszustwa gie\u0142dowe obejmuj\u0105 r\u00F3\u017Cne schematy wymierzone w inwestor\u00F3w poprzez fa\u0142szywe domy maklerskie, schematy pump-and-dump i oszuka\u0144czych doradc\u00F3w.',
      signs: 'Rodzaje oszustw gie\u0142dowych:',
      sign1: 'Schematy pump-and-dump sztucznie zawy\u017Caj\u0105ce ceny akcji',
      sign2: 'Fa\u0142szywe domy maklerskie i platformy handlowe online',
      sign3: 'Piramidy finansowe udaj\u0105ce fundusze inwestycyjne',
      sign4: 'Oszuka\u0144czy doradcy inwestycyjni i plani\u015Bci finansowi',
      sign5: 'Programy inwestycyjne o wysokiej stopie zwrotu (HYIP)',
      sign6: 'Oszustwa z zaliczk\u0105 na \u201Eekskluzywne\u201D okazje inwestycyjne',
      sign7: 'Nieautoryzowany handel i churning przez broker\u00F3w',
      howWeHelp: 'Nasza ekspertyza:',
      howWeHelpDesc: 'Nasz zesp\u00F3\u0142 obejmuje analityk\u00F3w finansowych i ekspert\u00F3w prawnych specjalizuj\u0105cych si\u0119 w oszustwach na rynku papier\u00F3w warto\u015Bciowych.',
      successTitle: 'Odzyskaj swoj\u0105 inwestycj\u0119',
      successDesc: 'Niezale\u017Cnie od tego, czy straci\u0142e\u015B pieni\u0105dze na fa\u0142szywym domu maklerskim czy pump-and-dump, mamy wiedz\u0119, aby pom\u00F3c.',
      cta: 'Odzyskaj swoje \u015Brodki'
    },
    otherPage: {
      title: 'Odzyskiwanie po innych oszustwach finansowych',
      subtitle: 'Kompleksowe us\u0142ugi odzyskiwania po wszelkich rodzajach oszustw finansowych',
      whatIs: 'Zajmujemy si\u0119 wszystkimi rodzajami oszustw finansowych',
      whatIsDesc: 'Poza naszymi specjalistycznymi us\u0142ugami pomagamy ofiarom wielu innych rodzaj\u00F3w oszustw finansowych. Je\u015Bli nie widzisz swojej sytuacji na li\u015Bcie, nadal mo\u017Cemy pom\u00F3c.',
      signs: 'Inne rodzaje oszustw, kt\u00F3rymi si\u0119 zajmujemy:',
      sign1: 'Oszustwa w zakupach online i na aukcjach',
      sign2: 'Oszustwa dotycz\u0105ce zatrudnienia i pracy zdalnej',
      sign3: 'Oszustwa loterii i nagr\u00F3d',
      sign4: 'Oszustwa zwi\u0105zane ze wsparciem technicznym',
      sign5: 'Kompromitacja biznesowej poczty e-mail (BEC)',
      sign6: 'Oszustwa fakturowe i przekierowanie p\u0142atno\u015Bci',
      sign7: 'Kradzie\u017C to\u017Csamo\u015Bci i oszustwa z syntetyczn\u0105 to\u017Csamo\u015Bci\u0105',
      howWeHelp: 'Nasze kompleksowe podej\u015Bcie:',
      howWeHelpDesc: 'Bez wzgl\u0119du na rodzaj oszustwa, nasze podej\u015Bcie jest takie samo: dok\u0142adne dochodzenie, zbieranie dowod\u00F3w i agresywne d\u0105\u017Cenie do odzyskania skradzionych \u015Brodk\u00F3w.',
      successTitle: 'Nie jeste\u015B pewien, czy mo\u017Cemy pom\u00F3c?',
      successDesc: 'Nawet je\u015Bli Twoja sprawa wydaje si\u0119 wyj\u0105tkowa lub skomplikowana, skontaktuj si\u0119 z nami. Nasza darmowa konsultacja pomo\u017Ce okre\u015Bli\u0107, czy mo\u017Cemy Ci pom\u00F3c.',
      cta: 'Om\u00F3w swoj\u0105 spraw\u0119'
    },
    regulationsPage: {
      euMicaTitle: 'EU MICA',
      euMicaSubtitle: '(ROZPORZ\u0104DZENIE W SPRAWIE RYNK\u00D3W KRYPTOAKTYW\u00D3W)',
      euMica1: 'Wymaga obowi\u0105zkowego licencjonowania dostawc\u00F3w us\u0142ug kryptoaktyw\u00F3w (CASP).',
      euMica2: 'Egzekwuje wymogi kapita\u0142owe, polisy ubezpieczeniowe i mechanizmy rezerwowe.',
      euMica3: 'Silne standardy ochrony konsument\u00F3w: przejrzyste ujawnianie ryzyka i \u015Brodki przeciwko oszustwom.',
      euMica4: 'Harmonizacja paneuropejska \u2014 jednolite zasady we wszystkich pa\u0144stwach cz\u0142onkowskich UE pod nadzorem ESMA i EBA.',
      auApraTitle: 'AU APRA',
      auApraSubtitle: '(AUSTRALIA\u0143SKI URZ\u0104D REGULACJI OSTRO\u017BNO\u015ACIOWEJ)',
      auApra1: 'Nadzoruje banki, ubezpieczycieli i fundusze emerytalne.',
      auApra2: 'Nak\u0142ada wymogi dotycz\u0105ce adekwatno\u015Bci kapita\u0142owej i oceny ryzyka kryptoaktyw\u00F3w.',
      auApra3: 'Wymaga test\u00F3w warunków skrajnych i zarz\u0105dzania ryzykiem stron trzecich.',
      auAsicTitle: 'AU ASIC',
      auAsicSubtitle: '(AUSTRALIA\u0143SKA KOMISJA PAPIER\u00D3W WARTO\u015ACIOWYCH I INWESTYCJI)',
      auAsicIntro: 'Reguluje us\u0142ugi kryptowalutowe jako produkty finansowe:',
      auAsic1: 'Wymaga licencji AFSL (Australian Financial Services Licence)',
      auAsic2: 'Egzekwuje standardy przechowywania, uczciwe ceny i zasady audytu dla krypto ETF.',
      caTitle: 'CA KANADYJSKIE RAMY REGULACYJNE',
      caOsfi: 'OSFI \u2014 Nadzoruje banki i ubezpieczycieli, zapewniaj\u0105c ochron\u0119 depozyt\u00F3w i stabilno\u015B\u0107 kapita\u0142ow\u0105.',
      caIiroc: 'IIROC \u2014 Reguluje broker\u00F3w inwestycyjnych i trader\u00F3w, zapewniaj\u0105c przejrzysto\u015B\u0107 i ochron\u0119 klient\u00F3w.',
      caCsa: 'CSA (za po\u015Brednictwem regulat\u00F3w prowincjonalnych) \u2014 Wymaga od platform kryptowalutowych:',
      caCsa1: 'Rejestracji i ujawniania ryzyk',
      caCsa2: 'Regularnych audyt\u00F3w i utrzymywania solidnych praktyk bezpiecze\u0144stwa',
      caCsa3: 'Segregacji \u015Brodk\u00F3w klient\u00F3w',
      usSecTitle: 'US SEC',
      usSecDesc: 'Komisja Papier\u00F3w Warto\u015Bciowych reguluje kryptowalutowe papiery warto\u015Bciowe i egzekwuje prawa ochrony inwestor\u00F3w w Stanach Zjednoczonych.',
      ukFcaTitle: 'UK FCA',
      ukFcaDesc: 'Urz\u0105d Nadzoru Finansowego nadzoruje firmy kryptowalutowe, wymagaj\u0105c rejestracji i zgodno\u015Bci z przepisami o przeciwdzia\u0142aniu praniu pieni\u0119dzy.'
    },
    privacyPage: {
      title: 'Polityka prywatno\u015Bci',
      subtitle: 'Twoja prywatno\u015B\u0107 jest dla nas wa\u017Cna',
      intro1: 'Twoja prywatno\u015B\u0107 jest dla nas wa\u017Cna. Polityk\u0105 TrustBack jest szanowanie Twojej prywatno\u015Bci w odniesieniu do wszelkich informacji, kt\u00F3re mo\u017Cemy od Ciebie zebra\u0107 na naszej stronie trustback.eu.',
      intro2: 'Prosimy o dane osobowe tylko wtedy, gdy naprawd\u0119 ich potrzebujemy. Zbieramy je w spos\u00F3b uczciwy i zgodny z prawem, za Twoj\u0105 wiedz\u0105 i zgod\u0105.',
      intro3: 'Przechowujemy zebrane informacje tylko tak d\u0142ugo, jak to konieczne. Chronimy dane za pomoc\u0105 komercyjnie akceptowalnych \u015Brodk\u00F3w.',
      intro4: 'Nie udost\u0119pniamy danych osobowych publicznie ani stronom trzecim, chyba \u017Ce wymaga tego prawo.',
      intro5: 'Nasza strona mo\u017Ce zawiera\u0107 linki do stron zewn\u0119trznych, kt\u00F3re nie s\u0105 przez nas obs\u0142ugiwane. Nie mamy kontroli nad ich zawarto\u015Bci\u0105.',
      intro6: 'Mo\u017Cesz odm\u00F3wi\u0107 podania danych osobowych, rozumiej\u0105c, \u017Ce mo\u017Cemy nie by\u0107 w stanie \u015Bwiadczy\u0107 niekt\u00F3rych us\u0142ug.',
      overviewTitle: 'Przegl\u0105d',
      overviewText1: 'Ta strona u\u017Cywa plik\u00F3w cookie, aby poprawi\u0107 Twoje do\u015Bwiadczenie. Pliki cookie niezb\u0119dne s\u0105 przechowywane w przegl\u0105darce, poniewa\u017C s\u0105 kluczowe dla podstawowych funkcji strony.',
      overviewText2: 'U\u017Cywamy tak\u017Ce plik\u00F3w cookie stron trzecich, kt\u00F3re pomagaj\u0105 nam analizowa\u0107 korzystanie ze strony. Te pliki s\u0105 przechowywane tylko za Twoj\u0105 zgod\u0105.',
      cookieTitle: 'Polityka plik\u00F3w cookie',
      cookieText1: 'Jak wi\u0119kszo\u015B\u0107 stron, nasze strony u\u017Cywaj\u0105 plik\u00F3w cookie do zbierania informacji. Pliki cookie to ma\u0142e pliki danych umieszczane na Twoim urz\u0105dzeniu.',
      cookieText2: 'Pliki cookie s\u0105 niezb\u0119dne do efektywnego dzia\u0142ania naszej strony i pomagaj\u0105 nam w reklamowaniu naszych us\u0142ug.',
      infoTitle: 'Zbierane informacje',
      infoText1: 'Niekt\u00F3re pliki cookie zbieraj\u0105 informacje o przegl\u0105daniu, gdy uzyskujesz dost\u0119p do naszych stron z tego samego urz\u0105dzenia.',
      infoText2: 'Wszystkie dane przekazywane przez pliki cookie s\u0105 anonimowe i nigdy nie zawieraj\u0105 danych osobowych.',
      managedTitle: 'Jak zarz\u0105dzane s\u0105 pliki cookie',
      managedText: 'Pliki cookie przechowywane na Twoim urz\u0105dzeniu s\u0105 projektowane przez:',
      managed1: 'Strony trzecie uczestnicz\u0105ce w naszych programach marketingowych; oraz',
      managed2: 'Strony trzecie uczestnicz\u0105ce w naszych programach marketingowych',
      usedTitle: 'Do czego s\u0142u\u017C\u0105 pliki cookie?',
      usedText: 'G\u0142\u00F3wne cele u\u017Cycia plik\u00F3w cookie to:',
      used1: 'Do cel\u00F3w funkcjonalnych niezb\u0119dnych do efektywnego dzia\u0142ania naszej strony.',
      used2: 'Do cel\u00F3w marketingowych i reklamowych, w szczeg\u00F3lno\u015Bci reklam i ukierunkowanych aktualizacji.',
      used3: 'Do cel\u00F3w analitycznych, w szczeg\u00F3lno\u015Bci us\u0142ug Google takich jak Google Analytics.',
      gaNotice1: 'Korzystaj\u0105c z tej strony, wyra\u017Casz zgod\u0119 na przetwarzanie danych o Tobie przez Google zgodnie z Polityk\u0105 Prywatno\u015Bci Google.',
      gaNotice2: 'Mo\u017Cesz zrezygnowa\u0107 z Google Analytics, wy\u0142\u0105czaj\u0105c pliki cookie, JavaScript lub korzystaj\u0105c z us\u0142ugi opt-out Google.',
      contactText: 'Je\u015Bli masz pytania dotycz\u0105ce przetwarzania danych osobowych, skontaktuj si\u0119 z nami'
    },
    cookie: {
      message: 'U\u017Cywamy plik\u00F3w cookie, aby poprawi\u0107 Twoje do\u015Bwiadczenie na naszej stronie. Kontynuuj\u0105c przegl\u0105danie, zgadzasz si\u0119 na u\u017Cycie plik\u00F3w cookie.',
      accept: 'Zaakceptuj wszystkie',
      decline: 'Odrzu\u0107',
      learnMore: 'Dowiedz si\u0119 wi\u0119cej'
    },
    footer: {
      description: 'Pomagamy ofiarom oszustw finansowych odzyska\u0107 skradzione pieni\u0105dze. Lata do\u015Bwiadczenia w dochodzeniach prawnych, kryptowalutowych i bankowych.',
      quickLinks: 'Szybkie linki',
      contact: 'Skontaktuj si\u0119 z nami',
      infoLine: 'Infolinia',
      consultationLine: 'Konsultacja ze specjalist\u0105',
      headOffice: 'Siedziba G\u0142\u00F3wna: 6 Pl. de la Pyramide, 92800 Puteaux, France \u2014 obs\u0142uga stacjonarna i online.',
      polishBranch: 'Oddzia\u0142 w Polsce: ul. Suwalska 25/27, 93-176 \u0141\u00F3d\u017A \u2014 wy\u0142\u0105cznie obs\u0142uga online.',
      complianceNote: '(Przej\u015Bcie na obs\u0142ug\u0119 online wynika z dostosowania do wymog\u00F3w unijnego rozporz\u0105dzenia MiCA oraz przepis\u00F3w AML w Polsce).',
      rights: 'Wszelkie prawa zastrze\u017Cone.'
    }
  }
};
